import { SAFE_TOKEN_GET } from '@/api/utils/safe'
import { getToken, setToken, removeToken, removeDigToken } from '@/utils/auth'
const { USER_LOGIN, USER_LOGOUT, USER_INFO_GET, WX_LOGIN } = require('@/api/user/user')

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    cartnum: 0,
    status: '',
    rank: {}
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_CARTNUM: (state, cartnum) => {
    state.cartnum = cartnum
  },
  SET_RANK: (state, rank) => {
    state.rank = rank
  },
  SET_STATUS: (state, status) => {
    state.status = status
  }
}

const actions = {
  // get safe token
  getSafeToken() {
    return new Promise((resolve, reject) => {
      SAFE_TOKEN_GET().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  //  reset safe token
  resetSafeToken() {
    return new Promise(resolve => {
      removeDigToken() // must remove  token  first
      resolve()
    })
  },

  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      USER_LOGIN(userInfo).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 微信登录
  wxLogin({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      WX_LOGIN(userInfo).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      USER_INFO_GET(state.token).then(response => {
        const { data } = response
        if (!data) {
          return reject(new Error('Verification failed, please Login again.'))
        }
        const { status, name, avatar, cartnum, rank } = data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_CARTNUM', cartnum)
        commit('SET_RANK', rank)
        commit('SET_STATUS', status)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      USER_LOGOUT({}).then(() => {
        removeToken() // must remove  token  first
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js